/**
 * Shared password validation rules used across Signup, ResetPassword, and Settings.
 * Single source of truth — update here to change rules everywhere.
 */

export const COMMON_PASSWORDS = new Set([
  'password', '123456', '12345678', '123456789', '1234567890', 'qwerty',
  'abc123', 'password1', 'iloveyou', 'sunshine', 'princess', 'football',
  'charlie', 'access', 'shadow', 'master', 'michael', 'superman', 'letmein',
  'trustno1', 'dragon', 'baseball', 'monkey', 'welcome', 'login', 'admin',
  'passw0rd', 'starwars', 'hello', '123123', '654321', 'password123',
  'qwerty123', 'password1234',
]);

export const PASSWORD_RULES = [
  { test: (p) => p.length >= 8, label: 'At least 8 characters' },
  { test: (p) => /[A-Z]/.test(p), label: 'One uppercase letter' },
  { test: (p) => /[a-z]/.test(p), label: 'One lowercase letter' },
  { test: (p) => /\d/.test(p), label: 'One number' },
  { test: (p) => /[^A-Za-z0-9]/.test(p), label: 'One special character' },
  { test: (p) => !COMMON_PASSWORDS.has(p.toLowerCase()), label: 'Not a commonly used password' },
];

export const isPasswordStrong = (password) =>
  PASSWORD_RULES.every((rule) => rule.test(password));
